// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2IHKA","checkboxCol":"Table_checkboxCol__35Yl2","emailCol":"Table_emailCol__eBS5P","actionCol":"Table_actionCol__2I_Re"};